// Set the google API Key
const APIKEY = 'AIzaSyALlREOuqN-Qk38RL_cQKFl9Z7488MZ494'
// This fires when the script is loaded. Its a Google things.
const CALLBACK_NAME = 'googleMapsCallback'

let initialized = !!window.google
let resolveInitPromise
let rejectInitPromise

const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
})

export default function init () {
  // Return if it is already initialzed
  if (initialized) return initPromise
  initialized = true

  // Wire up the callback to the window. This resolves once the script it loaded
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google)
  // Add a script to the page
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&callback=${CALLBACK_NAME}`
  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)

  return initPromise
}
